import classNames from 'classnames';
import React from 'react';

import { makeStyles } from '@material-ui/core';
import {
  Archive,
  AttachFile,
  Audiotrack,
  Code,
  Email,
  Folder,
  Photo,
  PhotoLibrary,
  PictureAsPdf,
  Videocam,
} from '@material-ui/icons';

import {
  Application,
  Audio,
  Image,
  Text,
  Video,
} from '../../../common/content-types';

const useStyles = makeStyles({
  icon: {
    width: '24px',
    height: '24px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconImage: {
    width: '80%',
    height: '80%',
  },
});

interface ItemIconProps {
  contentType: string;
}

export const ItemIcon: React.VFC<ItemIconProps> = ({ contentType }) => {
  const classes = useStyles();

  switch (contentType) {
    case Application.MetronFolder:
      return <Folder className={classes.icon} />;

    case Application.MetronAlbum:
      return (
        <PhotoLibrary className={classes.icon} style={{ color: '#e49e1e' }} />
      );

    case Application.Pdf:
      return (
        <PictureAsPdf className={classes.icon} style={{ color: '#da1313' }} />
      );

    case Application.JavaScript:
    case Application.Json:
    case Text.Html:
    case Text.Css:
      return <Code className={classes.icon} />;

    case Application.SevenZip:
    case Application.Rar:
    case Application.Zip:
      return <Archive className={classes.icon} />;

    case Text.Plain:
      return <AttachFile className={classes.icon} />;

    case Audio.Wav:
    case Audio.Mp4:
    case Audio.Mpeg:
      return <Audiotrack className={classes.icon} />;

    case Video.Mov:
    case Video.QuickTime:
    case Video.Mp4:
      return <Videocam className={classes.icon} />;

    case Application.MsWord:
    case Application.MsWordX:
      return (
        <div className={classNames(classes.icon, classes.iconContainer)}>
          <img
            src='/images/word.svg'
            alt='word'
            className={classes.iconImage}
          />
        </div>
      );

    case Application.MsExcel:
    case Application.MsExcelX:
      return (
        <div className={classNames(classes.icon, classes.iconContainer)}>
          <img
            src='/images/excel.svg'
            alt='excel'
            className={classes.iconImage}
          />
        </div>
      );

    case Application.MsPowerPoint:
    case Application.MsPowerPointX:
      return (
        <div className={classNames(classes.icon, classes.iconContainer)}>
          <img
            src='/images/powerpoint.svg'
            alt='powerpoint'
            className={classes.iconImage}
          />
        </div>
      );

    case Application.MsOutlook:
      return <Email />;

    case Image.Png:
    case Image.Jpeg:
      return <Photo className={classes.icon} />;

    default:
      return <AttachFile className={classes.icon} />;
  }
};
